"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType["DISCOUNT"] = "DISCOUNT";
    EventType["VOUCHER"] = "VOUCHER";
})(EventType = exports.EventType || (exports.EventType = {}));
//# sourceMappingURL=CodeRedemptionTypes.js.map